import { render } from "./IconMagnifyingGlass.vue?vue&type=template&id=3f325d64"
const script = {}
script.render = render

export default script